"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = require("react");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Tabs = require("./Tabs.styles");
var _Menu = require("../../UI/Menu");
var _hooks = require("../../hooks");
var _Tabs2 = require("./Tabs.labels");
var _jsxRuntime = require("react/jsx-runtime");
const Tabs = props => {
  const {
    id,
    defaultTabId,
    tabs,
    category,
    onTabClick
  } = props;
  const {
    isMobile
  } = (0, _hooks.useDeviceData)();
  const {
    outerDivRef,
    extraRef,
    contentRef,
    visibleChildren,
    setVisibleChildren,
    hiddenChildren,
    setHiddenChildren
  } = (0, _hooks.useListChildren)(tabs, isMobile);
  const getLabel = (0, _hooks.useLabels)({
    labels: _Tabs2.labels
  });
  const styles = (0, _Tabs.useStyles)();
  const [selectedTabId, setSelectedTabId] = (0, _react.useState)(defaultTabId ? defaultTabId : tabs?.length > 0 ? tabs[0]?.id : '');
  const [sliderClass, setSliderClass] = (0, _react.useState)('');
  const isSelectedTabVisible = (0, _react.useMemo)(() => visibleChildren?.findIndex(tab => selectedTabId && tab.id === selectedTabId) > -1, [selectedTabId, visibleChildren]);
  const handleTabClick = tab => {
    const visibleTabIndex = visibleChildren.findIndex(visibleTab => visibleTab.id === tab.id);
    const hiddenTabIndex = hiddenChildren.findIndex(hiddenTab => hiddenTab.id === tab.id);
    if (visibleTabIndex < 0 && hiddenTabIndex > -1) {
      const lastTab = visibleChildren[visibleChildren.length - 1];
      setVisibleChildren([tab, ...visibleChildren.slice(0, visibleChildren.length - 1)]);
      setHiddenChildren([lastTab, ...hiddenChildren.slice(0, hiddenTabIndex), ...hiddenChildren.slice(hiddenTabIndex + 1)]);
    }
    setSelectedTabId(tab.id);
    if (onTabClick) {
      onTabClick(tab);
    }
  };
  (0, _react.useEffect)(() => {
    const style = styles['cc-Tabs__slider'](selectedTabId, visibleChildren);
    setSliderClass(style);
  }, [visibleChildren, selectedTabId, styles]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: id,
    "data-testid": id ? `tabs-${id}` : 'tabs',
    className: styles['cc-Tabs'],
    ref: outerDivRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      ref: contentRef,
      className: styles['cc-Tabs__list'],
      role: "tablist",
      children: visibleChildren?.map(tab => {
        const isActive = selectedTabId === tab.id;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          role: "tab",
          "aria-selected": isActive,
          id: `tab_${tab.id}`,
          "data-testid": `tab_${tab.id}`,
          className: styles['cc-Tabs__tab'],
          "data-is-visible": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "text",
            color: isActive ? 'primary' : 'basic',
            category: category,
            label: tab.id,
            onClick: event => {
              event.preventDefault();
              event.stopPropagation();
              handleTabClick(tab);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: styles['cc-Tabs__tab__label'],
              children: [tab.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: tab.icon,
                width: 16,
                height: 16
              }), tab.label]
            })
          })
        }, tab.id);
      })
    }), isSelectedTabVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: sliderClass
    }), hiddenChildren.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: `tab_hidden`,
      className: styles['cc-Tabs__tab'],
      ref: extraRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
        btnProps: {
          view: 'text',
          role: 'tab',
          color: 'basic',
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: styles['cc-Tabs__tab__label'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Tabs__tab__dots'],
              children: "..."
            }), getLabel('more')]
          })
        },
        options: hiddenChildren.map(tab => ({
          value: tab.id,
          label: tab.label,
          isSelected: tab.id === selectedTabId,
          onClick: () => {
            handleTabClick(tab);
          }
        }))
      })
    }) : null]
  });
};
exports.Tabs = Tabs;